// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  width: 100%;
  height: 100%;
}

svg {
  touch-action: manipulation;
  box-sizing: border-box;
  pointer-events: painted;
}

.button-stack {
  position: absolute;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  bottom: calc(2rem + 2px);
  left: calc(3px + 0.5rem);
}`, "",{"version":3,"sources":["webpack://./src/app/components/svg-canvas/svg-canvas.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,WAAA;EACA,YAAA;AACF;;AAEA;EACE,0BAAA;EACA,sBAAA;EACA,uBAAA;AACF;;AAEA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,wBAAA;EACA,wBAAA;AACF","sourcesContent":[":host {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n\nsvg {\n  touch-action: manipulation;\n  box-sizing: border-box;\n  pointer-events: painted;\n}\n\n.button-stack {\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  bottom: calc(2rem + 2px);\n  left: calc(3px + 0.5rem);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
